import { routingKeyToCounty } from './routingKeyToCounty';

export const selfBuildCountySlugs = Array.from(
  new Set(Object.values(routingKeyToCounty).map((county) => county.toLowerCase()))
).sort();

export const SELF_BUILD_BED_TYPES: Array<2 | 3> = [2, 3];

export const toTitleCase = (value: string) =>
  String(value || '')
    .split('-')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');

export const toSelfBuildSlug = (countySlug: string, bedCount: 2 | 3) =>
  `cost-to-build-a-${bedCount}-bed-house-in-${countySlug}-2026`;
